import * as XLSX from "xlsx";
import { REQUIRED_FIELDS, OPTIONAL_FIELDS } from "@/lib/forecast";

export function downloadCSV(filename, rows, columns) {
  const cols = columns || (rows.length ? Object.keys(rows[0]) : []);
  const escape = (v) => {
    if (v === null || v === undefined) return "";
    const s = String(v);
    if (s.includes(",") || s.includes("\"") || s.includes("\n")) {
      return `"${s.replace(/"/g, '""')}"`;
    }
    return s;
  };
  const header = cols.join(",");
  const body = rows.map((r) => cols.map((c) => escape(r[c])).join(",")).join("\n");
  const blob = new Blob([header + "\n" + body], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export function downloadSampleTemplate() {
  const cols = [...REQUIRED_FIELDS, ...OPTIONAL_FIELDS];
  const sample = [
    { Site: "Plant-A", SKU: "HYD-4601", ItemName: "Hydraulic Oil ISO 46", Category: "Lubricants", Unit: "L", CurrentStock: 40, MinStock: 60, MaxStock: 400, HistoricalMonthlyUsage: 180, LeadTimeDays: 14, SupplierName: "LubeCo Industrial", UnitCost: 4.2, Criticality: "High", LastPurchaseDate: "2025-10-15", LastIssueDate: "2026-01-20", OpenPOQty: 0, MonthlyDemandMonth1: 160, MonthlyDemandMonth2: 175, MonthlyDemandMonth3: 190, MonthlyDemandMonth4: "", MonthlyDemandMonth5: "", MonthlyDemandMonth6: "", MaintenancePlanQty: 40, PlannedWorkOrders: 6, SupplierOTD: 82, SupplierFillRate: 90 },
    { Site: "Plant-A", SKU: "GRS-EP2", ItemName: "Grease EP2 Multipurpose", Category: "Lubricants", Unit: "KG", CurrentStock: 25, MinStock: 30, MaxStock: 200, HistoricalMonthlyUsage: 110, LeadTimeDays: 10, SupplierName: "LubeCo Industrial", UnitCost: 3.9, Criticality: "High", LastPurchaseDate: "2025-11-02", LastIssueDate: "2026-01-22", OpenPOQty: 60, MonthlyDemandMonth1: 115, MonthlyDemandMonth2: 108, MonthlyDemandMonth3: 120, MonthlyDemandMonth4: "", MonthlyDemandMonth5: "", MonthlyDemandMonth6: "", MaintenancePlanQty: 0, PlannedWorkOrders: 3, SupplierOTD: 82, SupplierFillRate: 90 },
    { Site: "Plant-B", SKU: "FIL-HEP-H13", ItemName: "HEPA Filter H13", Category: "Filters", Unit: "EA", CurrentStock: 4, MinStock: 10, MaxStock: 60, HistoricalMonthlyUsage: 18, LeadTimeDays: 30, SupplierName: "AirCare Solutions", UnitCost: 145, Criticality: "High", LastPurchaseDate: "2025-09-10", LastIssueDate: "2026-01-10", OpenPOQty: 0, MonthlyDemandMonth1: "", MonthlyDemandMonth2: "", MonthlyDemandMonth3: "", MonthlyDemandMonth4: "", MonthlyDemandMonth5: "", MonthlyDemandMonth6: "", MaintenancePlanQty: 0, PlannedWorkOrders: 2, SupplierOTD: 68, SupplierFillRate: 74 },
    { Site: "Plant-C", SKU: "PPE-GLV-NR-L", ItemName: "PPE Nitrile Gloves Large", Category: "PPE", Unit: "PAIR", CurrentStock: 800, MinStock: 400, MaxStock: 3000, HistoricalMonthlyUsage: 1200, LeadTimeDays: 21, SupplierName: "SafetyFirst Supplies", UnitCost: 0.22, Criticality: "High", LastPurchaseDate: "2025-12-01", LastIssueDate: "2026-01-25", OpenPOQty: 500, MonthlyDemandMonth1: 1150, MonthlyDemandMonth2: 1220, MonthlyDemandMonth3: 1280, MonthlyDemandMonth4: "", MonthlyDemandMonth5: "", MonthlyDemandMonth6: "", MaintenancePlanQty: 0, PlannedWorkOrders: 0, SupplierOTD: 84, SupplierFillRate: 88 },
    { Site: "Plant-A", SKU: "BRG-6205", ItemName: "Deep Groove Bearing 6205", Category: "Bearings", Unit: "EA", CurrentStock: 18, MinStock: 20, MaxStock: 100, HistoricalMonthlyUsage: 24, LeadTimeDays: 30, SupplierName: "RollPro Bearings", UnitCost: 11.5, Criticality: "High", LastPurchaseDate: "2025-10-28", LastIssueDate: "2026-01-14", OpenPOQty: 0, MonthlyDemandMonth1: "", MonthlyDemandMonth2: "", MonthlyDemandMonth3: "", MonthlyDemandMonth4: "", MonthlyDemandMonth5: "", MonthlyDemandMonth6: "", MaintenancePlanQty: 8, PlannedWorkOrders: 1, SupplierOTD: 72, SupplierFillRate: 80 },
  ];
  const ws = XLSX.utils.json_to_sheet(sample, { header: cols });
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "MRO Data");
  XLSX.writeFile(wb, "Avyntis_Sample_Template.xlsx");
}

export function parseUploadedFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const wb = XLSX.read(data, { type: "array", cellDates: true });
        const sheetName = wb.SheetNames[0];
        const ws = wb.Sheets[sheetName];
        const rows = XLSX.utils.sheet_to_json(ws, { defval: "", raw: false });
        const headers =
          (XLSX.utils.sheet_to_json(ws, { header: 1 })[0] || []).map((h) => String(h).trim());
        resolve({ rows, headers });
      } catch (err) {
        reject(err);
      }
    };
    reader.onerror = () => reject(new Error("Unable to read file"));
    reader.readAsArrayBuffer(file);
  });
}
